import moment from 'moment';
import { Availability } from 'types/availability';
import { ExplorersJournalRowType } from '../app/pages/ExplorersJournal/ExplorersJournal.types';
import { EXPLORERS_JOURNAL } from '../constants/ExplorersJournal.constants';

export const isEmpty = (obj: any) => Object.keys(obj).length === 0 && obj.constructor === Object;

export const transformToQueryParams = (params: any) =>
  !isEmpty(params)
    ? `?${Object.keys(params)
        .map(key => key + '=' + params[key])
        .join('&')}`
    : '';

// receives a date and an availability array and returns the availability value provided in the array
// if the date is contained in one of the intervals, else returns false (which means it is a VALID date).
export const isInvalidDate = (date: any, propertyAvailability: Availability[] | undefined): boolean => {
  let dateToCheck = moment(date);
  let isInvalidDate = false;
  let notAvailableDates: Availability[] = [];
  if (propertyAvailability?.length) {
    notAvailableDates = propertyAvailability.filter((each: Availability) => !each.available);
  }

  if (!!notAvailableDates && !!notAvailableDates.length && !isInvalidDate) {
    for (let index = 0; index < notAvailableDates.length; index++) {
      if (dateToCheck.isSame(moment(notAvailableDates[index].from), 'day')) {
        isInvalidDate = true;
      }
      if (isInvalidDate) break;
    }
  }

  return isInvalidDate;
};

export const isTheSameSearch = (actualSearch: string, newSearch: string): boolean => {
  let actualS = actualSearch.startsWith('?') ? actualSearch.slice(1) : actualSearch;
  let newS = newSearch.startsWith('?') ? newSearch.slice(1) : newSearch;
  return actualS === newS;
};

export const toNDecimals = (value: number, n: number = 2) => {
  return parseFloat(value.toFixed(n));
};

export const displayNDecimals = (value: number, n: number = 2) => {
  let displayValue = value != undefined ? value : 0;
  return Number(displayValue).toFixed(n);
};

export const formatDataFromSanityToExplorersJournals = (response: Array<any>) => {
  const formattedData: Array<ExplorersJournalRowType> = [];
  for (let resp of response) {
    switch (resp._type) {
      case EXPLORERS_JOURNAL.SANITY_TYPES.CITY_GUIDE:
        formattedData.push({
          sanityImage: resp.heroImage.asset._ref,
          city: resp?.city?.name || null,
          summary: resp.header,
          title: resp?.city?.name || null,
          type: 'City Guide',
          url: 'city-guide',
          slug: resp.slug.current
        });
        break;
      case EXPLORERS_JOURNAL.SANITY_TYPES.NEIGHBORHOOD_GUIDE:
        formattedData.push({
          sanityImage: resp.heroImage.asset._ref,
          city: resp.city.name,
          summary: resp.neighborhoodSummary,
          title: resp.neighborhood,
          type: 'Neighborhood Guide',
          url: 'neighborhood-guide',
          slug: resp.slug.current
        });
        break;
      case EXPLORERS_JOURNAL.SANITY_TYPES.LIVE_LIKE_A_LOCAL:
        formattedData.push({
          sanityImage: resp.heroImage.asset._ref,
          city: resp.city.name,
          summary: resp.header,
          title: resp.title,
          type: 'Live Like a Local',
          url: 'live-like-a-local',
          slug: resp.slug.current
        });
        break;
      case EXPLORERS_JOURNAL.SANITY_TYPES.EVENTS:
        if (!moment(Date.now()).isBetween(new Date(resp.startDisplay), new Date(resp.endDisplay), null, '[]')) break;
        formattedData.unshift({
          sanityImage: resp.heroImage.asset._ref,
          city: resp.city?.name,
          summary: resp?.header,
          title: resp.title,
          type: 'Holiday Like a Local',
          url: 'holiday-like-a-local',
          slug: resp.slug.current
        });
        break;
    }
  }
  return formattedData;
};

export function getInfoFromUrl(search: string, setPropertiesGuests: Function) {
  const urlParams = new URLSearchParams(search);
  const adultsCount = urlParams.get('adultsCount');
  const childrenCount = urlParams.get('childrenCount');
  const babiesCount = urlParams.get('babiesCount');
  const petsCount = urlParams.get('petsCount');
  if (adultsCount) {
    setPropertiesGuests('Adults', parseInt(adultsCount));
  }
  if (childrenCount) {
    setPropertiesGuests('Children', parseInt(childrenCount));
  }
  if (babiesCount) {
    setPropertiesGuests('Babies', parseInt(babiesCount));
  }
  if (petsCount) {
    setPropertiesGuests('Pets', parseInt(petsCount));
  }
}
